import "./form-hotel.scss";

import { HotelFormSchema } from "@factory/form/form.rule";
import CheckboxControl from "@shared/ui/hook-form/checkbox-control/checkbox-control";
import InputControl from "@shared/ui/hook-form/input-control/input-control";
import { useFormContext } from "react-hook-form";

import useAutocompleteLocation from "../../location/autocomplete-location/autocomplete-location";

type InputFormSchema = HotelFormSchema;
export function FormHotel() {
  const { control, setValue, getValues } = useFormContext<HotelFormSchema>();
  const { formElement: autocompleteLocation } = useAutocompleteLocation(
    getValues("location") || "",
    "location",
    "Location",
    "",
    (selectedLocation) => {
      setValue("location", selectedLocation?.value || "");
    }
  );
  return (
    <div id="FormHotel" className="hotel">
      <InputControl<InputFormSchema>
        control={control}
        name="name"
        label="Name"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter name"
      />
      {/* <InputControl<InputFormSchema>
        control={control}
        name="roomType"
        label="Room Type"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter roomType"
      /> */}
      <CheckboxControl<InputFormSchema>
        control={control}
        name="withBreakfast"
        label="With Breakfast"
        containerClassName="pb-2"
      />
      {autocompleteLocation}
      <InputControl<InputFormSchema>
        control={control}
        name="description"
        label="Description"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter description"
      />
    </div>
  );
}

export default FormHotel;
